// library imports
import * as Constants from "_core/configs/Constants";
import { getTime } from "_core/utils/common";

/**
 * 運営ツール: 動画最適化のエンコーダ（ffmpeg-core）取得 API
 * バイナリレスポンスを受け取るため、共通 ApiRequest (JSON前提) は使用せず fetch を直接使用する。
 * 失敗時は API のエラーメッセージを持つ Error を投げる
 * @returns {Promise<ArrayBuffer>}
 */
export const fetchOpsEncoderAsset = async (version, name) => {
    const params = new URLSearchParams();
    params.append("api_timestamp", getTime());
    params.append("is_editor", true);
    params.append("version", version);
    params.append("name", name);

    const response = await fetch(Constants.BASE_URL + "/admin/ops_encoder_asset", {
        mode: "cors",
        method: "POST",
        credentials: "include",
        headers: {
            accept: "*/*",
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params.toString(),
    });
    if (!response.ok) throw new Error(`Download failed: ${response.status}`);

    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
        const json = await response.json();
        const detail = json.error_detail || {};
        throw new Error(detail.message || Constants.UNKNOWN_ERROR_DETAIL);
    }
    return response.arrayBuffer();
};
